import React, { useEffect, useState, useCallback } from "react"
import Moment from "react-moment";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../store/auth";
import { getPartnerAllCandidate } from "../store/partner";
import { useLoadPartnerAllCandidateQuery } from "../store/partnerApiSlice";
import PurchaseOrders from "../../Components/ApplicantProcessing/PurchaseOrders";
import BulkInvoice from "../../Components/ApplicantProcessing/BulkInvoice";
import { setCurrentPageTitle, setCurrentRoute } from "../store/layoutUI";
import { getComponentUserStatus, getToolsCount, UpdateComponentsUserStatus } from "../store/tools";

const PARTNER_INVOICE_STYLES = {
    shell: {
        borderRadius: "20px",
        border: "1px solid rgba(226, 232, 240, 0.95)",
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    hero: {
        padding: "18px 22px",
        borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
        background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)"
    },
    heroRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    heroCopy: {
        flex: "1 1 360px",
        minWidth: "260px"
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px"
    },
    titleIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#2563eb",
        fontSize: "14px",
        border: "1px solid rgba(191, 219, 254, 0.9)",
        boxShadow: "0 4px 12px rgba(37, 99, 235, 0.06)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        minWidth: 0
    },
    title: {
        margin: 0,
        color: "#0f172a",
        fontSize: "18px",
        fontWeight: 600,
        lineHeight: 1.25
    },
    subtitle: {
        margin: "2px 0 0 0",
        color: "#64748b",
        fontSize: "13px",
        lineHeight: 1.4
    },
    heroActionRow: {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        borderRadius: "8px",
        border: "1px solid #cbd5e1",
        background: "#ffffff",
        color: "#334155",
        padding: "6px 14px",
        fontSize: "12.5px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
        cursor: "pointer",
        transition: "all 0.2s ease"
    },
    bulkButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        borderRadius: "8px",
        border: "1px solid #cbd5e1",
        background: "#ffffff",
        color: "#334155",
        padding: "6px 14px",
        fontSize: "12.5px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
        cursor: "pointer",
        transition: "all 0.2s ease"
    },
    statsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: "14px",
        padding: "20px 22px"
    },
    statCard: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(226, 232, 240, 0.95)",
        borderRadius: "16px",
        padding: "16px",
        boxShadow: "0 6px 18px rgba(15, 23, 42, 0.03)",
        transition: "all 0.2s ease"
    },
    statIcon: {
        width: "36px",
        height: "36px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eff6ff",
        color: "#2563eb",
        fontSize: "14px",
        flexShrink: 0
    },
    statContent: {
        minWidth: 0
    },
    statLabel: {
        margin: "0 0 4px 0",
        color: "#64748b",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase"
    },
    statValue: {
        margin: 0,
        color: "#0f172a",
        fontSize: "24px",
        fontWeight: 600,
        lineHeight: 1
    },
    tableWrap: {
        padding: "0"
    },
    tableShell: {
        overflowX: "auto",
        backgroundColor: "#ffffff"
    },
    table: {
        width: "100%",
        marginBottom: 0,
        borderCollapse: "separate",
        borderSpacing: 0,
        fontSize: "13px",
        color: "#334155"
    },
    tableHeadCell: {
        borderTop: "none",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
        padding: "14px 16px"
    },
    tableCell: {
        padding: "14px 16px",
        borderBottom: "1px solid rgba(241, 245, 249, 1)",
        verticalAlign: "top",
        fontWeight: 600
    },
    candidateAvatar: {
        width: "36px",
        height: "36px",
        borderRadius: "10px",
        background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#2563eb",
        fontSize: "13px",
        fontWeight: 600,
        border: "1px solid rgba(191, 219, 254, 0.9)",
        boxShadow: "0 2px 6px rgba(37, 99, 235, 0.08)",
        flexShrink: 0
    },
    candidateName: {
        margin: 0,
        color: "#0f172a",
        fontSize: "14px",
        fontWeight: 600,
        textTransform: "uppercase"
    },
    infoText: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        color: "#475569",
        fontSize: "12.5px",
        lineHeight: 1.45,
        fontWeight: 600
    },
    idPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "5px 10px",
        borderRadius: "999px",
        backgroundColor: "#eff6ff",
        border: "1px solid rgba(191, 219, 254, 0.9)",
        color: "#2563eb",
        fontSize: "12px",
        fontWeight: 600
    },
    secondaryPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "4px 10px",
        borderRadius: "999px",
        backgroundColor: "#f1f5f9",
        color: "#475569",
        fontSize: "12px",
        fontWeight: 600
    },
    statusBadge: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 12px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 600
    },
    actionButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        borderRadius: "8px",
        border: "1px solid #cbd5e1",
        background: "#ffffff",
        color: "#334155",
        padding: "6px 14px",
        fontSize: "12.5px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        whiteSpace: "nowrap"
    },
    emptyState: {
        padding: "42px 24px",
        textAlign: "center",
        backgroundColor: "#ffffff"
    },
    emptyIcon: {
        width: "64px",
        height: "64px",
        margin: "0 auto 14px auto",
        borderRadius: "18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
        color: "#2563eb",
        fontSize: "26px"
    },
    emptyTitle: {
        margin: 0,
        color: "#0f172a",
        fontSize: "18px",
        fontWeight: 600
    },
    emptyText: {
        margin: "10px auto 0 auto",
        maxWidth: "520px",
        color: "#64748b",
        fontSize: "14px",
        lineHeight: 1.6
    }
};

const PARTNER_INVOICE_ROUTE = [{ name: "Contract Management", url: "" }];

export default function PartnerInvoices() {

    const [candidateList, setCandidateList] = useState([]);
    const [candidateObj, setCandidateObj] = useState(null);
    const [poShowHide, setPoShowHide] = useState(false);
    const [bulkShowHide, setBulkShowHide] = useState(false);

    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const partnerAllCandidateSelector = useSelector(getPartnerAllCandidate);
    const componentUserStatusSelector = useSelector(getComponentUserStatus);
    const toolsCountSelector = useSelector(getToolsCount);

    const navigate = useNavigate();
    const currentUser = getCurrentUser();
    const currentUserId = currentUser?.id;
    const dispatch = useDispatch();

    const partnerId = (userDetailsSelector?.approved > 0) ? userDetailsSelector?.partnerid : null;
    const appApproved = userDetailsSelector?.approved > 0;
    const partnerType = userDetailsSelector?.partnerType;

    // RTK Query Hook
    const { refetch: refetchPartnerCandidates } = useLoadPartnerAllCandidateQuery(
        { partId: partnerId, perfId: 0 },
        { skip: !partnerId }
    );

    useEffect(() => {
        dispatch(setCurrentPageTitle("Invoices and Payments"));
        dispatch(setCurrentRoute(PARTNER_INVOICE_ROUTE));
    }, [dispatch]);

    useEffect(() => {
        let targetUsrId = currentUser?.linkUser || currentUser?.id;
        if (!userDetailsSelector && targetUsrId) {
            dispatch(loadUserDetails(targetUsrId));
        }
    }, [dispatch, currentUser, userDetailsSelector]);

    const handleUpdateComponent = useCallback((compItems, ciid) => {
        const comp = componentUserStatusSelector.filter(x => x.compId === 23);
        let updCompItems = "";
        if (comp.length > 0) {
            updCompItems = comp[0].compItems;
        }
        const compObj = {
            compName: "Partner Candidate Invoice",
            performerId: currentUserId,
            compItems: compItems,
            ciid: ciid,
            wiid: 0,
            iiid: 0,
            compId: 23
        }
        if (compItems !== "" && compItems !== updCompItems) {
            dispatch(UpdateComponentsUserStatus(compObj));
        }
    }, [componentUserStatusSelector, currentUserId, dispatch]);

    useEffect(() => {
        if (partnerAllCandidateSelector.length > 0) {
            setCandidateList(partnerAllCandidateSelector);
            let candItems = "";
            partnerAllCandidateSelector.forEach((x, key) => {
                if (key > 0) candItems += ",";
                candItems += x.performerid;
            });

            const appObj = toolsCountSelector?.filter(x => x.key === 0) || [];
            let appCiid = 0;
            if (appObj.length > 0)
                appCiid = appObj[0].value;

            handleUpdateComponent(candItems, appCiid);
        } else {
            setCandidateList([]);
        }
    }, [partnerAllCandidateSelector, toolsCountSelector, handleUpdateComponent]);

    const handleCandidateInnoice = useCallback((item) => {
        navigate("/CandidateInvoice", { state: item });
    }, [navigate]);

    const handlePoShowHide = useCallback((obj) => {
        setPoShowHide(prev => !prev);
        setCandidateObj(obj);
    }, []);

    const handleBulkShowHide = useCallback(() => {
        setBulkShowHide(prev => !prev);
    }, []);

    const getPendingPoCount = (obj) => {
        let poType = "recruiter";
        if (partnerType === "Sub-Contractors") {
            poType = "subcontractor";
        }

        return obj?.poTypes?.filter(x => x.type === poType && x.partnerSign !== true && x.sendStatus === true).length || 0;
    }

    const getTotalPoCount = (obj) => {
        let poType = "recruiter";
        if (partnerType === "Sub-Contractors") {
            poType = "subcontractor";
        }

        return obj?.poTypes?.filter(x => x.type === poType && x.sendStatus === true).length || 0;
    }

    const getPoCount = (obj) => {
        const pendingCount = getPendingPoCount(obj);
        const totalCount = pendingCount === 0 ? getTotalPoCount(obj) : pendingCount;
        const badgeBg = pendingCount === 0 ? "#dcfce7" : "#fee2e2";
        const badgeColor = pendingCount === 0 ? "#166534" : "#991b1b";

        return <span style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "18px",
            height: "18px",
            borderRadius: "999px",
            backgroundColor: badgeBg,
            color: badgeColor,
            fontSize: "11px",
            fontWeight: 600,
            padding: "0 6px",
            marginLeft: "6px"
        }}>
            {totalCount}
        </span>
    }

    const handleRefreshPartnerInvoices = useCallback(() => {
        if (userDetailsSelector && userDetailsSelector?.partnerid) {
            refetchPartnerCandidates();
        }
    }, [userDetailsSelector, refetchPartnerCandidates]);

    const getInitials = (firstName, lastName) => {
        const f = firstName ? firstName.trim().charAt(0) : "";
        const l = lastName ? lastName.trim().charAt(0) : "";
        return (f + l).toUpperCase() || "??";
    };

    const pendingCount = candidateList.length - candidateList.filter(item => item.appSubmit).length;
    const totalPendingPoCount = candidateList.reduce((sum, item) => sum + getPendingPoCount(item), 0);
    const invoiceReadyCount = candidateList.filter(item => item.appSubmit).length;

    const getOnboardingBadgeStyle = (isComplete) => ({
        ...PARTNER_INVOICE_STYLES.statusBadge,
        backgroundColor: isComplete ? "#f0fdf4" : "#fffbeb",
        color: isComplete ? "#166534" : "#92400e",
        border: `1px solid ${isComplete ? "#bbf7d0" : "#fde68a"}`
    });

    return <React.Fragment>

        <div className="mt-2">
            <style>{`
                .partner-invoices-table tbody tr:hover td {
                    background-color: #f8fbff !important;
                }

                @media (max-width: 991.98px) {
                    .partner-invoices-table {
                        min-width: 1040px;
                    }
                }
            `}</style>
            <div className="card shadow-none border-1" style={PARTNER_INVOICE_STYLES.shell}>
                <div style={PARTNER_INVOICE_STYLES.hero}>
                    <div style={PARTNER_INVOICE_STYLES.heroRow}>
                        <div style={PARTNER_INVOICE_STYLES.heroCopy}>
                            <div style={PARTNER_INVOICE_STYLES.titleRow}>
                                <span style={PARTNER_INVOICE_STYLES.titleIcon}>
                                    <i className="fa fa-money" aria-hidden="true"></i>
                                </span>
                                <div style={PARTNER_INVOICE_STYLES.titleText}>
                                    <h2 style={PARTNER_INVOICE_STYLES.title}>Invoices and Payments</h2>
                                    <p style={PARTNER_INVOICE_STYLES.subtitle}>
                                        Click on Go to Invoices button to generate monthly invoices for your candidates.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={PARTNER_INVOICE_STYLES.heroActionRow}>
                            <button
                                type="button"
                                className="btn btn-sm"
                                style={PARTNER_INVOICE_STYLES.refreshButton}
                                onClick={handleRefreshPartnerInvoices}
                            >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                Refresh
                            </button>
                            <button
                                className="btn btn-sm"
                                style={PARTNER_INVOICE_STYLES.bulkButton}
                                onClick={handleBulkShowHide}
                                disabled={!appApproved}
                            >
                                <i className="fa fa-files-o" aria-hidden="true"></i>
                                Generate Monthly Bulk Invoices
                            </button>
                        </div>
                    </div>
                </div>
                <div style={PARTNER_INVOICE_STYLES.statsGrid}>
                    <div style={PARTNER_INVOICE_STYLES.statCard}>
                        <div style={PARTNER_INVOICE_STYLES.statIcon}>
                            <i className="fa fa-users" aria-hidden="true"></i>
                        </div>
                        <div style={PARTNER_INVOICE_STYLES.statContent}>
                            <div style={PARTNER_INVOICE_STYLES.statLabel}>Total Candidates</div>
                            <div style={PARTNER_INVOICE_STYLES.statValue}>{candidateList.length}</div>
                        </div>
                    </div>
                    <div style={PARTNER_INVOICE_STYLES.statCard}>
                        <div style={PARTNER_INVOICE_STYLES.statIcon}>
                            <i className="fa fa-check-circle-o" aria-hidden="true"></i>
                        </div>
                        <div style={PARTNER_INVOICE_STYLES.statContent}>
                            <div style={PARTNER_INVOICE_STYLES.statLabel}>Invoice Ready</div>
                            <div style={PARTNER_INVOICE_STYLES.statValue}>{invoiceReadyCount}</div>
                        </div>
                    </div>
                    <div style={PARTNER_INVOICE_STYLES.statCard}>
                        <div style={PARTNER_INVOICE_STYLES.statIcon}>
                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                        </div>
                        <div style={PARTNER_INVOICE_STYLES.statContent}>
                            <div style={PARTNER_INVOICE_STYLES.statLabel}>Awaiting Onboarding</div>
                            <div style={PARTNER_INVOICE_STYLES.statValue}>{pendingCount}</div>
                        </div>
                    </div>
                    <div style={PARTNER_INVOICE_STYLES.statCard}>
                        <div style={PARTNER_INVOICE_STYLES.statIcon}>
                            <i className="fa fa-file-text-o" aria-hidden="true"></i>
                        </div>
                        <div style={PARTNER_INVOICE_STYLES.statContent}>
                            <div style={PARTNER_INVOICE_STYLES.statLabel}>Pending eSign</div>
                            <div style={PARTNER_INVOICE_STYLES.statValue}>{totalPendingPoCount}</div>
                        </div>
                    </div>
                </div>
                <div style={PARTNER_INVOICE_STYLES.tableWrap}>

                    <div className="table-responsive" style={PARTNER_INVOICE_STYLES.tableShell}>
                        <table className="table align-items-center table-hover mb-0 partner-invoices-table" style={PARTNER_INVOICE_STYLES.table}>
                            <thead>
                                <tr>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Candidate #<br />IPCS ID</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Candidate Details</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Agency</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Duration<br />(Start-End)</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Onboarding<br />Status</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Purchase Order</th>
                                    <th style={PARTNER_INVOICE_STYLES.tableHeadCell}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {candidateList.length > 0 && candidateList.map((item) => (
                                    <tr key={item.performerid}>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                                                <span style={PARTNER_INVOICE_STYLES.idPill}>
                                                    <i className="fa fa-user" aria-hidden="true" style={{ fontSize: "10px" }}></i>
                                                    {item.performerid}
                                                </span>
                                                <span style={PARTNER_INVOICE_STYLES.secondaryPill}>
                                                    {item.maxloans || "N/A"}
                                                </span>
                                            </div>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                                                <div style={PARTNER_INVOICE_STYLES.candidateAvatar}>
                                                    {getInitials(item.performername, item.lastName)}
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column", gap: "3px", minWidth: 0 }}>
                                                    <p style={PARTNER_INVOICE_STYLES.candidateName}>
                                                        {item.performername} {item.lastName}
                                                    </p>
                                                    {item.performeremail && (
                                                        <span style={PARTNER_INVOICE_STYLES.infoText}>
                                                            <i className="fa fa-envelope-o" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden="true"></i>
                                                            {item.performeremail}
                                                        </span>
                                                    )}
                                                    {item.contactNo && (
                                                        <span style={PARTNER_INVOICE_STYLES.infoText}>
                                                            <i className="fa fa-phone" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden="true"></i>
                                                            {getFormatedNumber(item.contactNo)}
                                                        </span>
                                                    )}
                                                    {getFieldData(item.performerData, "projectengagement", "PositionTitle") && (
                                                        <span style={{ ...PARTNER_INVOICE_STYLES.infoText, color: "#2563eb", fontWeight: 600, marginTop: "2px" }}>
                                                            <i className="fa fa-briefcase" style={{ fontSize: "11px" }} aria-hidden="true"></i>
                                                            {getFieldData(item.performerData, "projectengagement", "PositionTitle")}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <span style={{ ...PARTNER_INVOICE_STYLES.infoText, fontWeight: 600, color: "#0f172a" }}>
                                                <i className="fa fa-building-o" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden="true"></i>
                                                {getFieldData(item.performerData, "projectengagement", "AgencyName") || "N/A"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            {item.duration ? (
                                                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                                    <span style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                        padding: "3px 10px",
                                                        borderRadius: "6px",
                                                        backgroundColor: "#eff6ff",
                                                        border: "1px solid rgba(191, 219, 254, 0.9)",
                                                        color: "#2563eb",
                                                        fontSize: "11.5px",
                                                        fontWeight: 600,
                                                        width: "fit-content",
                                                        marginBottom: "4px"
                                                    }}>
                                                        <i className="fa fa-clock-o" style={{ fontSize: "10px" }} aria-hidden="true"></i>
                                                        {item.duration.duration} Months
                                                    </span>
                                                    <span style={PARTNER_INVOICE_STYLES.infoText}>
                                                        <i className="fa fa-calendar" style={{ fontSize: "10.5px", color: "#94a3b8" }} aria-hidden="true"></i>
                                                        Start: <Moment format="MMM Do YYYY">{item.duration.startDate}</Moment>
                                                    </span>
                                                    <span style={PARTNER_INVOICE_STYLES.infoText}>
                                                        <i className="fa fa-calendar-check-o" style={{ fontSize: "10.5px", color: "#94a3b8" }} aria-hidden="true"></i>
                                                        End: <Moment format="MMM Do YYYY">{item.duration.endDate}</Moment>
                                                    </span>
                                                </div>
                                            ) : (
                                                <span style={{ ...PARTNER_INVOICE_STYLES.infoText, color: "#94a3b8" }}>N/A</span>
                                            )}
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <span style={getOnboardingBadgeStyle(item.appSubmit)}>
                                                {item.appSubmit ? (
                                                    <i className="fa fa-check-circle" style={{ fontSize: "13px" }} aria-hidden="true"></i>
                                                ) : (
                                                    <i className="fa fa-clock-o" style={{ fontSize: "13px" }} aria-hidden="true"></i>
                                                )}
                                                {item.appSubmit ? "Complete" : "Pending"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <button
                                                className="btn btn-sm"
                                                onClick={() => handlePoShowHide(item)}
                                                style={PARTNER_INVOICE_STYLES.actionButton}
                                            >
                                                <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                                View and eSign
                                                {getPoCount(item)}
                                            </button>
                                        </td>
                                        <td style={PARTNER_INVOICE_STYLES.tableCell}>
                                            <button
                                                onClick={() => handleCandidateInnoice(item)}
                                                className="btn btn-sm"
                                                style={PARTNER_INVOICE_STYLES.actionButton}
                                            >
                                                <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                                Go To Invoices
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {candidateList.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="p-0">
                                            <div style={PARTNER_INVOICE_STYLES.emptyState}>
                                                <div style={PARTNER_INVOICE_STYLES.emptyIcon}>
                                                    <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                                </div>
                                                <h4 style={PARTNER_INVOICE_STYLES.emptyTitle}>No invoice candidates available yet</h4>
                                                <p style={PARTNER_INVOICE_STYLES.emptyText}>
                                                    Candidates will appear here once they are linked to your partner account and ready for invoice and payment tracking.
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <PurchaseOrders
            poShowHide={poShowHide}
            handlePoShowHide={handlePoShowHide}
            candidateObj={candidateObj}
        ></PurchaseOrders>
        <BulkInvoice
            bulkShowHide={bulkShowHide}
            handleBulkShowHide={handleBulkShowHide}
            candidateList={candidateList}
        ></BulkInvoice>
    </React.Fragment>
}
